//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: '',
  props: {
    breads: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    onClick: function onClick(path) {
      if (path) {
        if (this.$route.name == path) {
          this.$router.go(0);
        }

        this.$router.push({
          name: path
        });
      }
    }
  }
};